<template>
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="42.2727" cy="47.2727" r="42.2727" fill="#A51B32" fill-opacity="0.21"/>
    <path d="M25.0002 29.1667V16.6667C25.0002 15.5616 25.4392 14.5018 26.2206 13.7204C27.002 12.939 28.0618 12.5 29.1668 12.5H55.8918L64.2252 20.8333H87.5002C88.6052 20.8333 89.665 21.2723 90.4465 22.0537C91.2279 22.8351 91.6668 23.8949 91.6668 25V66.6667C91.6668 67.7717 91.2279 68.8315 90.4465 69.6129C89.665 70.3943 88.6052 70.8333 87.5002 70.8333H75.0002V83.3333C75.0002 84.4384 74.5612 85.4982 73.7798 86.2796C72.9984 87.061 71.9386 87.5 70.8335 87.5H12.5002C11.3951 87.5 10.3353 87.061 9.55388 86.2796C8.77248 85.4982 8.3335 84.4384 8.3335 83.3333V33.3333C8.3335 32.2283 8.77248 31.1685 9.55388 30.3871C10.3353 29.6057 11.3951 29.1667 12.5002 29.1667H25.0002ZM25.0002 37.5H16.6668V79.1667H66.6668V70.8333H25.0002V37.5ZM33.3335 20.8333V62.5H83.3335V29.1667H60.7752L52.4418 20.8333H33.3335Z" fill="#142454"/>
  </svg>
</template>

<script>
export default {
  name: "PastasDeArquivos"
}
</script>

<style scoped>

</style>
